// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TvQl","label":"styles_label__2frE7"};